import React, { useState } from 'react'
import { Resource } from '../../utils/interfaces'
import Dropdown from './Dropdown';
import { databaseName, supportedVersions } from '../../utils/constants';
import { useEventListener } from '@iwbam/react-ez';
import { config } from '../../config';

interface Props {
  resource: Resource
  setResource: React.Dispatch<React.SetStateAction<undefined | null | Resource>>
  mainClass: string
  setMainClass: React.Dispatch<React.SetStateAction<string>>
  description: string
  setDescription: React.Dispatch<React.SetStateAction<string>>
  version: string
  setVersion: React.Dispatch<React.SetStateAction<string>>
  saveConfig: () => void
}

const ConfigSettings: React.FC<Props> = (props) => {

  const [isShowingDropdown, setIsShowingDropdown] = useState(false);

  useEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest('.versions-dropdown') && !target.closest('.versions-input')) {
      setIsShowingDropdown(false);
    }
  });

  return (
    <div className='flex-1 flex flex-col items-center scroller'>
      <div className='flex flex-col max-w-xl w-5/6 *:w-full my-10'>
        <label className='text-xs m-0.5 mt-8'>Main class</label>
        <input placeholder='The main class name of the plugin' className='border rounded bg-gray-800 p-1 text-sm' value={props.mainClass} onInput={(e: React.ChangeEvent<HTMLInputElement>) => props.setMainClass(e.target.value)} />
        <label className='text-xs m-0.5 mt-8'>Version</label>
        <div className='relative'>
          <input className='versions-input cursor-pointer w-full border rounded bg-gray-800 p-1 text-sm' onClick={() => setIsShowingDropdown(!isShowingDropdown)} readOnly value={props.version} />
          {isShowingDropdown && <div className='versions-dropdown absolute overflow-hidden w-full max-h-64 scroller flex flex-col bg-gray-800 border rounded' style={{ top: '110%' }}>
            {supportedVersions.map(version => <button onClick={() => {
              props.setVersion(version);
              setIsShowingDropdown(false);
            }} className='text-sm text-left p-1 px-2 hover:bg-gray-700' key={`v-option-${version}`}>{version}</button>)}
          </div>}
        </div>
        <label className='text-xs m-0.5 mt-8'>Description</label>
        <input placeholder='A description about the plugin' className='border rounded bg-gray-800 p-1 text-sm' value={props.description} onInput={(e: React.ChangeEvent<HTMLInputElement>) => props.setDescription(e.target.value)} />
        <div className='flex items-center mt-8'>
          <button onClick={props.saveConfig} className='bg-emerald-500 p-1 px-4 text-sm font-bold rounded active:bg-emerald-600'>Save</button>

        </div>
      </div>
    </div>
  )
}

export default ConfigSettings